import {
  IAccountDetails,
  IBasePatient,
  IBillingEntity,
  IContact,
  IPatientContactDetails,
  IPractice,
  isPractice,
  IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { NameHelpers } from '../patient/name-helpers';

export function toAccountDetails(
  entity:
    | (IBasePatient & Partial<IPatientContactDetails>)
    | IPractice
    | {
        patient: IBasePatient;
        primaryContact: IBasePatient & IPatientContactDetails;
      }
    | { patient: IBasePatient; contact: IContact }
    | { practice: IPractice; billingEntity: IBillingEntity }
    | { staffer: IStaffer; billingEntity: IBillingEntity }
): IAccountDetails {
  if (isPractice(entity)) {
    return {
      name: NameHelpers.fullName(entity.name),
      address: entity.address,
      phone: entity.phone,
    };
  }

  if ('patient' in entity) {
    if ('primaryContact' in entity) {
      return {
        ...toAccountDetails(entity.primaryContact),
        onBehalfOf: toAccountDetails(entity.patient),
      };
    }

    return {
      name: NameHelpers.fullName(entity.contact.name),
      address: entity.contact.address || '',
      phone: entity.contact.phone || '',
      onBehalfOf: toAccountDetails(entity.patient),
    };
  }

  if ('practice' in entity) {
    return {
      name: entity.billingEntity.displayName || entity.practice.name,
      address: entity.billingEntity.entity.address || entity.practice.address,
      phone: entity.practice.phone,
      taxId: `${entity.billingEntity.entity.registrationNumberType}: ${entity.billingEntity.entity.registrationNumber}`,
    };
  }

  if ('staffer' in entity) {
    return {
      name: entity.billingEntity.displayName || entity.staffer.user.name,
      address: entity.billingEntity.entity.address || '',
      taxId: `${entity.billingEntity.entity.registrationNumberType}: ${entity.billingEntity.entity.registrationNumber}`,
    };
  }

  return {
    name: NameHelpers.fullName(entity.name),
    address: entity.address ?? '',
  };
}
